import { render, staticRenderFns } from "./prescriptionImage.vue?vue&type=template&id=62c79b4e&scoped=true"
import script from "./prescriptionImage.vue?vue&type=script&lang=js"
export * from "./prescriptionImage.vue?vue&type=script&lang=js"
import style0 from "./prescriptionImage.vue?vue&type=style&index=0&id=62c79b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c79b4e",
  null
  
)

export default component.exports